/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const HowToGuides32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlGray80}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 5a3 3 0 00-3 3v16.5A2.5 2.5 0 009.5 27H24a1 1 0 001-1V7a2 2 0 00-2-2H10zm14 18H9.5a1.5 1.5 0 000 3H24v-3zm-8.004-12c-.22 0-.424.018-.613.054a2.983 2.983 0 00-.988.374 3.435 3.435 0 00-.395.273l.403.593a.34.34 0 00.314.175.377.377 0 00.187-.052c.063-.035.135-.073.22-.116a1.532 1.532 0 01.734-.167c.226 0 .404.057.533.167.13.112.194.262.194.45a.75.75 0 01-.116.422 1.52 1.52 0 01-.282.32c-.112.096-.23.184-.359.268a2.834 2.834 0 00-.346.264 1.058 1.058 0 00-.243.31.63.63 0 00-.05.403l.108.757h1.042l.137-.658a.528.528 0 01.16-.264c.084-.079.182-.158.295-.238.113-.08.233-.167.359-.261.126-.094.242-.205.346-.334.105-.129.192-.28.261-.454.069-.175.103-.381.103-.62 0-.25-.047-.479-.14-.685a1.465 1.465 0 00-.4-.527 1.8 1.8 0 00-.632-.336 2.699 2.699 0 00-.832-.118zm-.227 5.39a.875.875 0 00-.617.235.764.764 0 00-.248.57.776.776 0 00.248.574.838.838 0 00.273.17.96.96 0 00.344.061.888.888 0 00.615-.231.776.776 0 00.25-.574.756.756 0 00-.25-.57.905.905 0 00-.615-.235z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default HowToGuides32;
